import { Record, Map } from "immutable";
import { EventResultRecord, eventResultFromJSON } from "common/records/EventResult";
import { RootActions, RootState } from "common/reducers";
import { EventResultActions, RECEIVE_EVENT_RESULT, RECEIVE_EVENT_RESULTS } from "common/reducers/eventResult.actions";

export const EventResultStateRecord = Record({
  byId: Map<number, EventResultRecord>(),
});

export const initialState = EventResultStateRecord();
export type EventResultState = typeof initialState;

export const model = "eventResults";
export const reducer = (state: RootState, action: RootActions): RootState => {
  switch (action.type) {
    case RECEIVE_EVENT_RESULT:
      const result = eventResultFromJSON(action.payload.result);
      return state.setIn([model, "byId", result.id], result);

    case RECEIVE_EVENT_RESULTS:
      action.payload.results.forEach((result) => {
        state = reducer(state, EventResultActions.receiveEventResult(result));
      });
      return state;

    default:
      return state;
  }
};
